import { render, staticRenderFns } from "./VizJsOutput.vue?vue&type=template&id=2fe22876&scoped=true"
import script from "./VizJsOutput.vue?vue&type=script&lang=js"
export * from "./VizJsOutput.vue?vue&type=script&lang=js"
import style0 from "./VizJsOutput.vue?vue&type=style&index=0&id=2fe22876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe22876",
  null
  
)

export default component.exports